import api from './api';
import type { Decision } from './sessions';

export interface EventTypeCount24h {
  event_type: string;
  count: number;
  critical_count: number;
}

export interface SessionRiskRow {
  session_uuid: string;
  hwid: string;
  ip: string;
  risk_score: number;
  decision: Decision;
  decision_real: Decision;
  last_heartbeat: string;
}

export interface DailyReport {
  generated_at: string;
  window_seconds: number;
  events_total: number;
  events_by_type: EventTypeCount24h[];
  sessions: {
    total: number;
    risk_above_50: number;
    decision_real_flag: number;
    decision_real_kick: number;
    decision_real_block: number;
    decision_real_diff_from_response: number;
  };
  top_risk_sessions: SessionRiskRow[];
}

export async function getDailyReport(windowHours = 24, topN = 10): Promise<DailyReport> {
  const resp = await api.get<DailyReport>('/admin/reports/daily', {
    params: { window_hours: windowHours, top_n: topN },
  });
  return resp.data;
}

// Helpers de export — operação local (sem dep externa).
export function reportToCsv(r: DailyReport): string {
  const lines: string[] = [];
  lines.push('# Daily report');
  lines.push(`generated_at,${r.generated_at}`);
  lines.push(`window_seconds,${r.window_seconds}`);
  lines.push(`events_total,${r.events_total}`);
  lines.push(`sessions_total,${r.sessions.total}`);
  lines.push(`sessions_risk_above_50,${r.sessions.risk_above_50}`);
  lines.push(`decision_real_flag,${r.sessions.decision_real_flag}`);
  lines.push(`decision_real_kick,${r.sessions.decision_real_kick}`);
  lines.push(`decision_real_block,${r.sessions.decision_real_block}`);
  lines.push(`decision_real_diff_from_response,${r.sessions.decision_real_diff_from_response}`);
  lines.push('');
  lines.push('# events_by_type');
  lines.push('event_type,count,critical_count');
  for (const e of r.events_by_type) {
    lines.push(`${csvEscape(e.event_type)},${e.count},${e.critical_count}`);
  }
  lines.push('');
  lines.push('# top_risk_sessions');
  lines.push('session_uuid,hwid,ip,risk_score,decision,decision_real,last_heartbeat');
  for (const s of r.top_risk_sessions) {
    lines.push([
      csvEscape(s.session_uuid),
      csvEscape(s.hwid),
      csvEscape(s.ip),
      s.risk_score,
      s.decision,
      s.decision_real,
      csvEscape(s.last_heartbeat),
    ].join(','));
  }
  return lines.join('\n');
}

function csvEscape(value: string): string {
  if (/[,"\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}
